// The colours the records charts draw with, apart from Chart.js itself so
// the pure line assembly (and its tests, which run without a canvas) can
// read them without registering a chart engine.
import { designVariables } from "@studio3t/design-variables";

const P = designVariables.primitives;

/** The three lines of one pipeline's records series, as the Figma mock
 *  draws them (3TL-Bridge node 16142-97938): violet for watched, sky blue
 *  for dropped, red for incomplete, from Figma's rainbow/original set. The
 *  design-variables package does not carry that set yet (its rainbow set
 *  is the older hues at 30% alpha), so the hues are spelled out here
 *  with their variable names until the tokens are re-exported. The wash
 *  under the watched line is its hue at 10%. */
const WATCHED_HUE = "#aea1ff"; // rainbow/original/violet
export const SERIES_COLORS = {
  watched: WATCHED_HUE,
  watchedFill: `${WATCHED_HUE}1a`,
  dropped: "#9dcff5", // rainbow/original/sky-blue
  incomplete: "#f5a6a6", // rainbow/original/red
};

/** One hue per pipeline when several share a plot (TTTL-304): the design
 *  system's auxiliary set (Design System - Web App, primitives collection,
 *  auxiliary/c1 to c7), in its own order, so a pipeline's hue is its place
 *  in the fence and never its rank. The design-variables package does not
 *  carry the set yet, so the values are spelled out here with their
 *  variable names until the tokens are re-exported. Several of these sit
 *  under 3:1 against the card, which the legend, the tooltip and the table
 *  behind the canvas make up for. */
export const PIPELINE_COLORS: readonly string[] = [
  "#f9625b", // auxiliary/c1
  "#e87522", // auxiliary/c2
  "#07c71b", // auxiliary/c3
  "#0cd1e9", // auxiliary/c4
  "#7186fa", // auxiliary/c5
  "#b7afed", // auxiliary/c6
  "#d15fea", // auxiliary/c7
];

export const GRID_COLOR = P.neutrals.alpha.b10;
export const TICK_COLOR = P.neutrals[110];
